// extracted by mini-css-extract-plugin
module.exports = {"button":"ZoomOutControl_button__dmbbL","container":"ZoomOutControl_container__sCQId"};